import { store } from '@wajeez-web/stores/base';
import { CollectionComponetsActions } from '@wajeez-web/stores/content';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';
import {
  actions,
  createCollectionComponentByTypeIdMultilingualAsync,
  editCollectionComponentMultilingualAsync,
  getCollectionComponentByIdMultilingualAsync,
} from './slices';

export const getCollectionComponentsBodyLookups = async (
  data: { searchText?: string },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    CollectionComponetsActions.getCollectionComponentBodyLookupsAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const getCollectionComponentsStandAloneLookups = async (
  data: { searchText?: string },
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    CollectionComponetsActions.getCollectionComponentsStandAloneLookupsAsync(
      data
    )
  );

  return handleDispatchResult(res, onSuccess);
};

export const getCollectionComponentByIdMultilingual = async (
  id: string,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    getCollectionComponentByIdMultilingualAsync(id)
  );

  return handleDispatchResult(res, onSuccess);
};

export const createCollectionComponentByTypeIdMultilingual = async (
  data: Server.CreateCollectionComponentByTypeIdV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    createCollectionComponentByTypeIdMultilingualAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const editCollectionComponentMultilingual = async (
  data: Server.EditCollectionComponentV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    editCollectionComponentMultilingualAsync(data)
  );

  return handleDispatchResult(res, onSuccess);
};

export const clearCollectionComponentByIdMultilingual = async () => {
  store.dispatch(actions.clearCollectionComponentByIdMultilingual());
};
